import { DefineComponentProps } from 'utils'
import { PositionItemLayout } from '../layouts/PositionInfo.layout'
import { useBaseInfoStore, useExchangeInfoStore, useProjectTheme, UserDoubleContractUnitType, useUserCenterContractOrderStore } from 'store'
import { useI18n } from 'i18n-utils'
import { OrderDirection } from 'network'
import { ListCell, Pnl, Tag } from '..'
import classNames from 'classnames'
import { CopyText } from '../components/Copy'

interface HistoricalTradeItemProps {
  data: ApiResponse.HistoricalTrade
  divider?: boolean
}

export const HistoricalTradeItem = defineComponent<HistoricalTradeItemProps>({
  props: DefineComponentProps<HistoricalTradeItemProps>(['data', 'divider']),
  setup(props) {
    const baseInfoStore = useBaseInfoStore()
    const exchangeStore = useExchangeInfoStore()
    const themeStore = useProjectTheme()
    const theme = computed(() => themeStore.theme)
    const { t } = useI18n()
    const contractOrderListStore = useUserCenterContractOrderStore()
    const coinIcon = computed(() => {
      const url = baseInfoStore.getContractCoinIconUrlBySymbolId(props.data.symbolId)
      return url || ''
    })

    const getOpenName = (symbolId: SymbolId) => {
      if (contractOrderListStore.userDoubleContractUnitType === UserDoubleContractUnitType.Coin) {
        return contractOrderListStore.getOpenName(symbolId)
      }
      return 'USDT'
    }

    const amount = computed(() => {
      const num = contractOrderListStore.getDealInterestTrade(props.data)
      return contractOrderListStore.userDoubleContractUnitType === UserDoubleContractUnitType.Coin ? num.formatCommonMoney() : num.multiplyStr(props.data.price).formatCommonMoney()
    })

    return () => (
      <PositionItemLayout class={classNames('position-item', { divider: props.divider })}>
        <div class="symbol-coin-info">
          <img width={32} height={32} src={coinIcon.value} alt="coin icon" />
          <div class="coin-info">
            <div class="coin-name">
              {exchangeStore.getContractSymbolName(props.data.symbolId)} {t('永续')}
            </div>

            <div class="flex info-tags gap-4">
              <Tag color={props.data.direction === OrderDirection.Buy ? theme.value.colors.up : theme.value.colors.down}>{contractOrderListStore.getOrderType(props.data)}</Tag>
            </div>
          </div>
        </div>
        <div class="position-info">
          <ListCell title={t('已实现盈亏')} description={<Pnl value={props.data.pnl}>USDT</Pnl>} />

          <ListCell title={t('成交价格')} description={`${props.data.price.formatNumberWithCommas()} USDT`} />

          <ListCell title={t('成交数量')} description={`${amount.value} ${getOpenName(props.data.symbolId)}`} />

          <ListCell title={t('手续费')} description={`${props.data.fee.formatNumberWithCommas()} USDT`} />

          <ListCell title={t('角色')} description={props.data.isMaker === -1 ? t('吃单') : t('挂单')} />
          {/* 订单号 */}
          <ListCell title={t('订单号')} description={<CopyText value={props.data.orderNo || props.data.tid} isRenderCopyText />} />
        </div>
      </PositionItemLayout>
    )
  },
})
